module.exports = __webpack_public_path__ + "static/media/YM01_6.bbfadb06.jpg";